import React from "react";

const DOC_TYPES = [
  "GOODS_RECEIPT",
  "GOODS_ISSUE",
  "TRANSFER",
  "ASSET_ISSUE",
  "ASSET_RETURN",
  "ADJUSTMENT",
];

export default function DocumentHeaderForm({
  value,
  onChange,
  warehouses = [],
  locations = [],
  partners = [],
  disabled = false, // ✅ DODATO
}) {
  const setField = (field, fieldValue) => {
    if (disabled) return; // ✅ BLOKADA

    onChange({
      ...value,
      [field]: fieldValue,
    });
  };

  const inputClass =
    "w-full border rounded-lg px-3 py-2 disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed";

  return (
    <div className="bg-white rounded-xl shadow-sm border p-4">
      <h3 className="text-lg font-semibold mb-4">Document Header</h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Document Type */}
        <div>
          <label className="block text-sm font-medium mb-1">Document Type</label>
          <select
            className={inputClass}
            value={value.doc_type || ""}
            disabled={disabled}
            onChange={(e) => setField("doc_type", e.target.value)}
          >
            <option value="">Select type</option>
            {DOC_TYPES.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>

        {/* Document Date */}
        <div>
          <label className="block text-sm font-medium mb-1">Document Date</label>
          <input
            type="date"
            className={inputClass}
            value={value.doc_date || ""}
            disabled={disabled}
            onChange={(e) => setField("doc_date", e.target.value)}
          />
        </div>

        {/* Posting Date */}
        <div>
          <label className="block text-sm font-medium mb-1">Posting Date</label>
          <input
            type="date"
            className={inputClass}
            value={value.posting_date || ""}
            disabled={disabled}
            onChange={(e) => setField("posting_date", e.target.value)}
          />
        </div>

        {/* Source Warehouse */}
        <div>
          <label className="block text-sm font-medium mb-1">Source Warehouse</label>
          <select
            className={inputClass}
            value={value.source_warehouse_id || ""}
            disabled={disabled}
            onChange={(e) =>
              setField(
                "source_warehouse_id",
                e.target.value ? Number(e.target.value) : null
              )
            }
          >
            <option value="">Select warehouse</option>
            {warehouses.map((w) => (
              <option key={w.id} value={w.id}>
                {w.code} - {w.name}
              </option>
            ))}
          </select>
        </div>

        {/* Target Warehouse */}
        <div>
          <label className="block text-sm font-medium mb-1">Target Warehouse</label>
          <select
            className={inputClass}
            value={value.target_warehouse_id || ""}
            disabled={disabled}
            onChange={(e) =>
              setField(
                "target_warehouse_id",
                e.target.value ? Number(e.target.value) : null
              )
            }
          >
            <option value="">Select warehouse</option>
            {warehouses.map((w) => (
              <option key={w.id} value={w.id}>
                {w.code} - {w.name}
              </option>
            ))}
          </select>
        </div>

        {/* Partner */}
        <div>
          <label className="block text-sm font-medium mb-1">Partner</label>
          <select
            className={inputClass}
            value={value.partner_id || ""}
            disabled={disabled}
            onChange={(e) =>
              setField("partner_id", e.target.value ? Number(e.target.value) : null)
            }
          >
            <option value="">Select partner</option>
            {partners.map((p) => (
              <option key={p.id} value={p.id}>
                {p.code} - {p.name}
              </option>
            ))}
          </select>
        </div>

        {/* Source Location */}
        <div>
          <label className="block text-sm font-medium mb-1">Source Location</label>
          <select
            className={inputClass}
            value={value.source_location_id || ""}
            disabled={disabled}
            onChange={(e) =>
              setField(
                "source_location_id",
                e.target.value ? Number(e.target.value) : null
              )
            }
          >
            <option value="">Select location</option>
            {locations.map((l) => (
              <option key={l.id} value={l.id}>
                {l.code} - {l.name}
              </option>
            ))}
          </select>
        </div>

        {/* Target Location */}
        <div>
          <label className="block text-sm font-medium mb-1">Target Location</label>
          <select
            className={inputClass}
            value={value.target_location_id || ""}
            disabled={disabled}
            onChange={(e) =>
              setField(
                "target_location_id",
                e.target.value ? Number(e.target.value) : null
              )
            }
          >
            <option value="">Select location</option>
            {locations.map((l) => (
              <option key={l.id} value={l.id}>
                {l.code} - {l.name}
              </option>
            ))}
          </select>
        </div>

        {/* Currency */}
        <div>
          <label className="block text-sm font-medium mb-1">Currency</label>
          <input
            type="text"
            className={inputClass}
            value={value.currency || "RSD"}
            disabled={disabled}
            onChange={(e) => setField("currency", e.target.value)}
          />
        </div>
      </div>

      {/* Remarks */}
      <div className="mt-4">
        <label className="block text-sm font-medium mb-1">Remarks</label>
        <textarea
          className={inputClass + " min-h-[90px]"}
          value={value.remarks || ""}
          disabled={disabled}
          onChange={(e) => setField("remarks", e.target.value)}
          placeholder="Notes, explanation, reference..."
        />
      </div>
    </div>
  );
}